import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconReport32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconReport32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 5h12a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2M6 7a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H10a4 4 0 0 1-4-4zm5 1a1 1 0 1 0 0 2h9a1 1 0 1 0 0-2zm-1 5a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2h-5a1 1 0 0 1-1-1m5.021 5.293-.707-.707-.707.707-3.314 3.314a1 1 0 1 0 1.414 1.414l2.607-2.607 2.607 2.607.707.707.707-.707 3.314-3.314a1 1 0 0 0-1.414-1.414L17.628 20.9z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconReport32);
